import { render, staticRenderFns } from "./policy-regulatory.vue?vue&type=template&id=bd091a2c&scoped=true&"
import script from "./policy-regulatory.vue?vue&type=script&lang=js&"
export * from "./policy-regulatory.vue?vue&type=script&lang=js&"
import style0 from "./policy-regulatory.vue?vue&type=style&index=0&id=bd091a2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd091a2c",
  null
  
)

export default component.exports